import SalesFunnel from "@/landing/salesfunnel.tsx";
import {createFileRoute} from '@tanstack/react-router'

export const Route = createFileRoute('/salesfunnel')({
    component: RouteComponent,
})

function RouteComponent() {
    return <SalesFunnel />
}
